<div class="stepper" *transloco="let t">
  <ng-container *ngIf="activeIndex < steps.length; else loginTemplate">
    <p-card class="step-card">
      <ng-template pTemplate="content">
        <div class="card-content">
          <img
            class="step-img"
            [src]="'assets/images/icons/' + steps[activeIndex].icon + '.png'"
            [alt]="t('stepper.steps')[activeIndex].title" />
          <div class="step-title">{{ t('stepper.steps')[activeIndex].title }}</div>
          <div class="step-body">{{ t('stepper.steps')[activeIndex].text }}</div>
        </div>
        <div class="button-row">
          <p-button
            [label]="t('stepper.buttons.skip')"
            class="p-button-text"
            styleClass="p-button-outline"
            (click)="skip()"></p-button>
          <p-button
            [label]="t('stepper.buttons.next')"
            icon="pi pi-arrow-right"
            iconPos="right"
            [style]="{ borderRadius: '0.5rem' }"
            (click)="next()"
            [disabled]="activeIndex === steps.length"></p-button>
        </div>
      </ng-template>
    </p-card>
  </ng-container>
  <ng-template #loginTemplate>
    <p-card class="step-card" [styleClass]="firstOpenApp ? 'hide-login' : ''">
      <app-login-signup></app-login-signup>
    </p-card>
  </ng-template>
  <cookie-consent-component></cookie-consent-component>
</div>
